import cx from 'classnames';
import moment from 'moment';
import type { VoidFunctionComponent } from 'react';

import KPICard from './KPICard';
import type { IssueCount } from '../../../shared/types/routes/issueCounts';

import styles from './IssueOverview.module.less';
import useIssueOverview from './hooks/useIssueOverview';

type Props = {
  items: IssueCount[];
  isLoading: boolean;
};

const emptySnapshot = {
  active: 0,
  ignored: 0,
  remediated: 0,
};

const KPISection: VoidFunctionComponent<Props> = ({ items, isLoading }) => {
  const { filters } = useIssueOverview();
  const currentSnapshot = items[items.length - 1];
  const firstSnapshot = items[0];
  // There's an edge case where if the selected date range goes further back than the creation of the first snapshot,
  // then we need to use an "empty" snapshot of all zeroes to compare against.
  const previousSnapshot =
    firstSnapshot?.date && moment(firstSnapshot.date).isAfter(moment(filters.start)) ? emptySnapshot : firstSnapshot;

  return (
    <div className={cx(styles.section, styles.kpiSection)}>
      <KPICard
        title="Total Issues"
        current={currentSnapshot ? currentSnapshot.active + currentSnapshot.ignored + currentSnapshot.remediated : null}
        previous={
          previousSnapshot ? previousSnapshot.active + previousSnapshot.ignored + previousSnapshot.remediated : null
        }
        isLoading={isLoading}
      />
      <KPICard
        title="Total Active Issues"
        current={currentSnapshot?.active ?? null}
        previous={previousSnapshot?.active ?? null}
        isLoading={isLoading}
      />
      <KPICard
        title="Total Ignored Issues"
        current={currentSnapshot?.ignored ?? null}
        previous={previousSnapshot?.ignored ?? null}
        isLoading={isLoading}
      />
      <KPICard
        title="Total Remediated Issues"
        current={currentSnapshot?.remediated ?? null}
        previous={previousSnapshot?.remediated ?? null}
        isLoading={isLoading}
      />
    </div>
  );
};

export default KPISection;
